<template>
    <h1>Términos de uso</h1>
</template>